import { BiMicrophone } from "react-icons/bi"; 
import React from "react";
import { useTable } from "react-table";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import * as FxFetch from '../fx/FxFetch';
import * as FxStr from '../fx/FxStr';
import * as FxDat from '../fx/FxDat';
import * as FxTable from '../fx/FxTable';
import CxInput from '../cx/CxInput';
import CxDate from '../cx/CxDate';
import CxCombo from '../cx/CxCombo';
import CxLink from '../cx/CxLink';
import CxHr from '../cx/CxHr';
import CxNumber from '../cx/CxNumber';
import { useTranslation } from '../hx/useTranslation';
import '../../styles/main.css';
import '../../styles/Table/Table.css';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import CxDialog from './CxDialog';
import CxProgress from "./CxProgress";
import CxMultiCheck from "./CxMultiCheck";
import CxDlgAlert from "./CxDlgAlert";
import { useWindowSize } from '../hx/useWindowSize';
import CxIconButtonNew from "./CxIconButtonNew";
import CxIconButtonMenu from "./CxIconButtonMenu";
import { IoCaretForwardCircleOutline } from "react-icons/io5";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { IoPlaySkipBackCircleOutline } from "react-icons/io5";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoAddCircleOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import CxDlgUpgrade from './CxDlgUpgrade';
import { BiInfoCircle } from "react-icons/bi";
import { getStoreValue, getStoreValueBo } from "../gx/GxStore";


const CxTable = ({ onOpenForm, onOptions, onSpecialOptions, onFetchPage, onFetchEmpty, onReady, columns, onRowHover, onRowLeave, fxTooltipText, ...rest }) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  const BUTTON_FONTSIZE = 28;

  const TUID = React.useRef(null); // table unique id

  const [progress, setProgress] = React.useState(false);

  const [tooltip, setTooltip] = React.useState(rest.tooltip);
  React.useEffect(() => setTooltipText(rest.tooltip), [rest.tooltip]); // mantiene actualizado el tooltip.

  const [search, setSearch] = React.useState('');
  const [pageNo, setPageNo] = React.useState(0);
  const [data, setPageData] = React.useState([]);
  const [filter, setFilter] = React.useState(rest.filter || '');
  const [filterHaving, setFilterHaving] = React.useState(rest.filterHaving || '');
  const [addParams, setAddParams] = React.useState(rest.addParams || '');
  const [timeElapsed, setTimeElapsed] = React.useState(0);
  const [cursor, setCursor] = React.useState(rest.cursor || 'pointer');

  const [disabled, setDisabled] = React.useState(rest.disabled);
  React.useEffect(() => setDisabled(rest.disabled), [rest.disabled]); // mantiene actualizado la habilitación, si se cambia el valor isDisabled en la llamada.
  const [disabledAlert, setDisabledAlert] = React.useState('');

  const [refColors, setRefColors] = React.useState(rest.refColors || '');
  const [refSuffixes, setRefSuffixes] = React.useState(rest.refSuffixes || ''); // 2025-03-01 - daq: para añadir a una celda un texto, por ejemplo '/i', ex en la tabla: refSuffixes={[`/i|${trans('field.patient')}-${trans('field.inactive')}`,]} 

  const [obTooltip, setObTooltip] = React.useState({ 
    boShow: false, 
    nuX: 0, 
    nuY: 0, 
    txText: '' 
  });
  
  let txUrl = React.useRef(rest.url);

  const rf_search = React.useRef(null);
  const rf_button_action1 = React.useRef(null);
  const rf_button_add = React.useRef(null);
  const rf_optional_columns = React.useRef(null);
  const rf_optional_sorting = React.useRef(null);
  const rf_optional_from = React.useRef(null);
  const rf_optional_to = React.useRef(null);

  const r_is_editing = React.useRef(false);
  const r_is_empty = React.useRef(true);
  const r_dlg_alert = React.useRef(null);
  
  const r_dlg_upgrade = React.useRef(null);
  
  const [dlgOptions, setDlgOptions] = React.useState(false);
  const [dlgGotoPage, setDlgGotoPage] = React.useState(false);
  const rf_goto_page = React.useRef(null);

  const [dlgInfo, setDlgInfo] = React.useState(false);
  const [infoTotal, setInfoTotal] = React.useState(false);

  const [isRequired, setIsRequired] = React.useState(false);

  const {
    getTableProps,
    headerGroups,
    rows,
    allColumns,
    prepareRow,
  } = useTable({
    columns,
    data,
    initialState: {
      hiddenColumns: columns.map(column => {
        if (column.show === false) { return column.id } else { return null };
      }),
    }
  });


  React.useEffect(() => {
    setTableID(rest.id);
    FxLog.infox('CxTable.useEffect(1)', '...TUID.current:', TUID.current);

    if (rest.optionalSorting && !rest.id) {
      FxLog.errorx("CxTable.useEffect(1)", "THIS TABLE HAS ORDERING BUT NEEDS ID!!");
    }
    setIsRequired(rest.required !== undefined);

    if (rest.buttonAddOptions) {
      setButtonAddOptions(rest.buttonAddOptions);
    }

    let search = sessionStorage.getItem(TUID.current + '_search') || "";
    Promise.all([sessionStorage.getItem(TUID.current + '_pageno')]).then((result) => {
      let pageno = Number(result[0]);
      if (rest.hasSearchBox) {
        if (search.length > 0) {
          rf_search.current.setVal(search);
          Promise.all([setSearch(search)]).then(() => {
            fetchPage(search, pageno);
          });
        } else {
          if (size.isLarge && rest.focusSearchBox) {
            rf_search.current.setFocus();
          }
          fetchPage(search, pageno);
        }
      } else {
        fetchPage(search, pageno);
      }
    }).then(() => {
      // Aquí notificamos que la tabla ya está lista
      if (onReady) {
        onReady();
      }
    });

    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    FxLog.infox('CxTable.useEffect(2)', '...', );
    function handleResize() {
      fetchPage(search, 0);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    return () => {
      if (!r_is_editing.current) {
        FxLog.infox('CxTable.useEffect(3)', '...', );

        if (getStoreValueBo('StoreSession', 'boShowTabs')) { 
          // 2026-03-25 - daq: permito recordar búsqueda en tablas al volver a la pestaña
        } else {
          // elimino búsqueda
          sessionStorage.removeItem(TUID.current + '_search');
        }
      }
      r_is_editing.current = false;
    };
    // eslint-disable-next-line
  }, []);


  React.useImperativeHandle(rest.xref, () => {
    return {
      getType, redisplay, refresh, isEmpty, getIsRequired, getLabel, highlightText, highlightDate, getFilter, setFilter, getFilterHaving, setFilterHaving,
      setAddParams, setSearchForced, setTooltipText, getTooltipText, clearSearch, getSearchText, getOptionalFrom, getOptionalTo, goPagePrev, goPageNext,
      setRefColors, setRefSuffixes, setTableID, clearTable, setButtonAddOptions, getButtonAddTooltip, setDisabled, cellFormat, setCursor, setDisabledAlert
    };
  });
  const getType = () => { return 'CxTable' };
  const getFilter = () => { return filter };
  const getFilterHaving = () => { return filterHaving };
  const getIsRequired = () => { return isRequired && isEmpty() };
  const getLabel = () => { return rest.label || '' }; /* DAQ 2022.05.13 - trabaja con required */
  const goPageFirst = () => handleChangePage(0);
  const goPagePrev = () => handleChangePage(pageNo === 0 ? pageNo : pageNo - 1);
  const goPageNext = () => handleChangePage(pageNo + 1);
  const goToPage = (newPage) => handleChangePage(newPage - 1);
  const setTableID = (newID) => { TUID.current = 'CxTable_' + rest.url + '_' + (newID || '') };
  const getButtonAddTooltip = () => { return rf_button_add.current.getTooltip() }; 

  const clearTable = () => {
    setPageData([]);
  }

  const setButtonAddOptions = (newOptions) => {
    if (rf_button_add.current) {
      rf_button_add.current.setOptions(newOptions);
    }
  };

  const setTooltipText = (theTooltip) => {
    setTooltip(theTooltip);
    if (rf_search.current) {
      rf_search.current.setTooltipText(theTooltip);
    }
  };

  const getTooltipText = () => {
    return rf_search.current.getTooltipText();
  };

  const setSearchForced = async (search) => {
    if (search) {
      FxLog.infox('CxTable.setSearchForced', '...', );
      rf_search.current.setVal(search);
      return Promise.all([setSearch(search)]).then((result) => {
        return fetchPage(search, 0);
      });
    }
  };

  const redisplay = async (url) => {
    FxLog.infox('CxTable.redisplay', '...', );
    if (url) {
      txUrl.current = url;
    }
    return fetchPage(search, 0);
  };

  const refresh = async () => {
    FxLog.infox('CxTable.refresh', '...', );
    return fetchPage(search, pageNo);
  };

  const isEmpty = () => {
    return r_is_empty.current;
  };

  const escapeRegExpMatch = function (s) { return s.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&') };
  const isExactMatch = (str, match) => { return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str) }

  const highlightText = (cellVal, colId) => {
    if (cellVal && rest.hasSearchBox) {
      let highlight = search;
      if (search) {
        if (highlight.includes(':') || highlight.includes('=')) {
          const separator = highlight.includes(':') ? ':' : '=';
          const field = highlight.split(separator)[0].toLowerCase();
          const value = highlight.split(separator)[1].trim().toLowerCase();

          if (colId) {
            const col = allColumns.find(c => c.id === colId);
            const colHeader = col ? String(col.Header).toLowerCase() : '';
            if (isExactMatch(colHeader, field)) {
              return FxStr.highlightSearch(cellVal, value);
            } else {
              return cellVal;
            }
          } else {
            // fallback legacy: no resalta en búsquedas campo:valor
            return cellVal;
          }

        } else if (highlight.includes('+')) {
          let fields = highlight.split('+');
          let rv;
          for (let index = 0; index < fields.length; index++) {
            const hl = fields[index].trim();
            if (cellVal.toLowerCase().includes(hl.toLowerCase())) {
              rv = FxStr.highlightSearch(cellVal, hl);
            }
          }
          return rv || cellVal;

        } else {
          return FxStr.highlightSearch(cellVal, highlight);
        }
      } else {
        return cellVal;
      }
    }
  }

  const highlightDate = (cellVal, colId) => {
    if (cellVal && rest.hasSearchBox) {
      const strHighlight = search;
      const strIsoDate = String(cellVal).substring(0, 10);

      if (strHighlight.includes('+')) {
        const arrFields = strHighlight.split('+');
        for (let intIndex = 0; intIndex < arrFields.length; intIndex++) {
          const strHl = arrFields[intIndex].trim();
          if (strIsoDate.toLowerCase().includes(FxDat.toIsoDate(strHl))) {
            if (search && FxDat.isValidDtIso(FxDat.toIsoDate(strHl))) {
              return FxStr.highlightSearch(FxTable.cellToLocalDate(strIsoDate), strHl);
            }
          }
        }
        return FxTable.cellToLocalDate(strIsoDate);

      } else if (strHighlight.includes(':') || strHighlight.includes('=')) {
        const separator = strHighlight.includes(':') ? ':' : '=';
        const field = strHighlight.split(separator)[0].toLowerCase();
        const value = strHighlight.split(separator)[1].trim();

        if (colId) {
          const col = allColumns.find(c => c.id === colId);
          const colHeader = col ? String(col.Header).toLowerCase() : '';
          if (isExactMatch(colHeader, field) && FxDat.isValidDtIso(FxDat.toIsoDate(value))) {
            return FxStr.highlightSearch(FxTable.cellToLocalDate(strIsoDate), value);
          }
        }
        return FxTable.cellToLocalDate(strIsoDate);

      } else {
        if (search && FxDat.isValidDtIso(FxDat.toIsoDate(strHighlight))) {
          return FxStr.highlightSearch(FxTable.cellToLocalDate(strIsoDate), strHighlight);
        } else {
          return FxTable.cellToLocalDate(strIsoDate);
        }
      }
    }
    return cellVal;
  };

  const cellFormat = (value, format, colId) => {
    let rv = { color: '', value: value };
    if (value && format) {
      if (format.includes('ht')) rv.value = highlightText(value, colId);
      if (format.includes('hd')) rv.value = highlightDate(value, colId);
      if (format.includes('colorA')) rv.color = 'var(--ibs_color_gray)';
    }
    return <span style={{ color: rv.color }}>{ rv.value }</span>;
  }

  /* DAQ 2021.09.01 -  */
  const getCellClassName = (cell, colIndex) => {
    let rv = 'table_cell';
    FxLog.infox('CxTable.getCellClassName', '...cursor:', cursor);

    // para cada columna, la muestra con cursor correspondiente
    switch (cell.column.cursor) {
      case 'notallowed':
        rv += ' table_cell_cursor_notallowed';
        break;
    
      default:
        if (disabled) {
          rv += ' table_cell_cursor_default';
        } else {
          if (cursor==='pointer') rv += ' table_cell_cursor_pointer';
          if (cursor==='default') rv += ' table_cell_cursor_default';
        }
        break;
    }

    // para cada fila, la muestra con el color correspondiente
    allColumns.forEach((column, iCol) => {
      let cellValue = cell.row.allCells[iCol].value;
      //FxLog.infox('CxTable.getCellClassName', '...cellValue:', cellValue);
      if (cellValue) {
        if (column.id === 'R' && !rv.includes('table_cell_color')) rv += ' table_cell_color_red';
        if (column.id === 'B' && !rv.includes('table_cell_color')) rv += ' table_cell_color_blue';
        if (column.id === 'Y' && !rv.includes('table_cell_color')) rv += ' table_cell_color_yellow';
        if (column.id === 'W' && !rv.includes('table_cell_color')) rv += ' table_cell_color_brown';
        if (column.id === 'P' && !rv.includes('table_cell_color')) rv += ' table_cell_color_pink';
        if (column.id === 'A' && !rv.includes('table_cell_color')) rv += ' table_cell_color_gray';
        if (column.id === 'G' && !rv.includes('table_cell_color')) rv += ' table_cell_color_green';
      }
    });
    return rv;
  }

  /* by daq 06.08.21 */
  const getHeaderSetting = (colIndex, setting) => {
    let rv = '';
    headerGroups.forEach(headerGroup => {
      headerGroup.headers.forEach((column, iCol) => {
        if (colIndex === iCol) {
          rv = column[setting];
        }
      });
    });
    return rv;
  }

  const handleChangePage = async (newPageNo) => {
    FxLog.infox('CxTable.handleChangePage', '...', );
    return fetchPage(search, newPageNo);
  };

  const formAdd = (option) => {
    FxLog.infox('CxTable.formAdd', '...option:', option);
    if (disabled) {
      if (disabledAlert) {
        r_dlg_alert.current.setText(disabledAlert);
        r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
        r_dlg_alert.current.setHasButtonClose(true);
        r_dlg_alert.current.setOpen(true);
      }
    } else {
      if (rest.disabledUntilUpgrade) {
        r_dlg_upgrade.current.setOpen(true);
      } else {
        r_is_editing.current = true;
        if (onOpenForm) {
          let op = "c";
          if (option) {
            op = `c:${option}`
          }
          onOpenForm(op, null);
        }
      }
    }
  };

  const formUpdate = (cell, ctrlKey) => {
    if (disabled) {
      FxLog.infox('CxTable.formUpdate', '...:', );
      if (disabledAlert) {
        r_dlg_alert.current.setText(disabledAlert);
        r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
        r_dlg_alert.current.setHasButtonClose(true);
        r_dlg_alert.current.setOpen(true);
      }
    } else {
      r_is_editing.current = true;
      if (onOpenForm) {
        let col_id = cell.column.id;
        if (!String(col_id).startsWith('BTN_')) { // 2023-05-09 - daq: si no se pulsó algún botón de línea.
          let rowAndMore = { ...cell.row, col_id, ctrlKey };
          onOpenForm("u", rowAndMore);
        }
      }
    }
  };

  const clearSearch = async () => {
    FxLog.infox('CxTable.clearSearch', '...', );
    rf_search.current.setVal('');
    return Promise.all([setSearch('')]).then((result) => {
      return fetchPage('', 0);
    });
  };

  const getSearchText = () => {
    if (rf_search.current) {
      return rf_search.current.getVal();
    } else {
      return '';
    }
  };

  const getOptionalFrom = () => {
    return localStorage.getItem(TUID.current + '_date_from');
  };
  const getOptionalTo = () => {
    return localStorage.getItem(TUID.current + '_date_to');
  };

  const optionsSelected = () => {
    try {
      setDlgOptions(false);

      if (onOptions) {
        if (rf_optional_columns.current) {
          onOptions(rf_optional_columns.current.getVal());
        }
      }

      if (rf_optional_from.current && rf_optional_to.current) {
        let from = rf_optional_from.current.getVal();
        let to = rf_optional_to.current.getVal();
        if (from.length === 0) {
          localStorage.removeItem(TUID.current + '_date_from');
        } else {
          localStorage.setItem(TUID.current + '_date_from', from);
        }
        if (to.length === 0) {
          localStorage.removeItem(TUID.current + '_date_to');
        } else {
          localStorage.setItem(TUID.current + '_date_to', to);
        }
        // redesplegamos para que muestre ordenamiento
        redisplay();
      }

      if (rf_optional_sorting.current) {
        let sortingField = rf_optional_sorting.current.getKey();
        if (sortingField.length === 0) {
          localStorage.removeItem(TUID.current + '_sorting');
        } else {
          localStorage.setItem(TUID.current + '_sorting', sortingField);
        }
        // redesplegamos para que muestre ordenamiento
        redisplay();
      }

    } catch (error) {
      FxLog.errorx("CxTable.optionsSelected", error);
    }
  }

  // Fetch page
  const fetchPage = async (newSearch, newPageNo) => {
    //FxLog.infox('CxTable.fetchPage', '...newPageNo:', newPageNo);
    if (rest.hasSearchBox) {
      sessionStorage.setItem(TUID.current + '_search', newSearch);
    }
    sessionStorage.setItem(TUID.current + '_pageno', newPageNo);
    //-----------------------------------------------------------------------
    let pageSize = null;
    let spaceForSearchBox = 0;
    if (rest.hasSearchBox) {
      spaceForSearchBox = 60;
    } else {
      spaceForSearchBox = 0;
    }
    let spaceForTitle = 0;
    if (rest.title) {
      spaceForTitle = 90;
    } else {
      spaceForTitle = 0;
    }
    let windowHeight = 0;
    if (rest.windowHeight) {
      windowHeight = rest.windowHeight;
    } else {
      windowHeight = window.innerHeight;
    }
    let spaceForAppBar = 150;
    let rowH = 40; /* debe coincidir con Table.css > ibs_table_row_height */
    let spaceForColumnTitle = rowH;
    if (rest.fullscreen) {
      let total = (windowHeight - spaceForAppBar - spaceForSearchBox - spaceForTitle - spaceForColumnTitle);
      pageSize = parseInt(total / rowH) - 1/*ajuste*/;
    } else {
      pageSize = 5;
    }
    //-----------------------------------------------------------------------

    let dateFrom = localStorage.getItem(TUID.current + '_date_from');
    let dateTo = localStorage.getItem(TUID.current + '_date_to');
    let sortBy = localStorage.getItem(TUID.current + '_sorting') || "dtCrea";
    let group = '';
    if (rest.group) {
      group = rest.group;
    }

    // record
    let record = {};
    record['searchText'] = newSearch;
    record['tooltip'] = tooltip;
    record['pageNo'] = newPageNo;
    record['pageSize'] = pageSize;
    record['dateFrom'] = dateFrom;
    record['dateTo'] = dateTo;
    record['sortBy'] = sortBy;
    record['filter'] = filter;
    record['filterHaving'] = filterHaving;
    record['group'] = group;
    if (addParams) {
      let params = addParams.split("&");
      params.forEach(function (item, index) {
        record[item.split("=")[0]] = item.split("=")[1];
      });
    }
    const startTime = Date.now();
    setProgress(true);
    r_is_empty.current = true;
    return Promise.all([FxFetch.doJsonX(txUrl.current, record)]).then((result) => {
      let rv = '';
      setProgress(false);
      if (result[0]) {
        if (!Array.isArray(result[0])) {
          FxLog.infox('CxTable.fetchPage', '...NULL RESULT!');
          rv = 'FETCH-ERROR: NULL';
        } else {
          FxLog.infox('CxTable.fetchPage', '...HAS RESULT!');
          setSearch(newSearch);
          setPageNo(newPageNo);
          setPageData(result[0]);
          const millis = Date.now() - startTime;
          //FxLog.infox('CxTable.fetchPage', '...seconds elapsed:', `${Math.floor(millis / 1000)}`);
          setTimeElapsed(Math.floor(millis / 1000));
          if (newPageNo === 0) {
            if (result[0].length > 0) {
              r_is_empty.current = false;
            } else {
              if (onFetchEmpty) {
                onFetchEmpty();
              }
            }
          }
          rv = 'FETCH-OK';
        }
      }
      if (onFetchPage) {
        onFetchPage(newPageNo);
      }
      return rv;
    });
  }

  const doSearch = async () => {
    FxLog.infox('CxTable.doSearch', '...', );
    return fetchPage(rf_search.current.getVal(), 0);
  }

  const getStyle = () => {
    let style = 'ibs_table';
    if (disabled) style += ' disabled';
    return style;
  }

  const doDisplayInfo = () => {
    try {
      Promise.all([getTotal()]).then((result) => {
        setInfoTotal(result[0]);
        setDlgInfo(true);
      });

    } catch (error) {
      FxLog.errorx("CxTable.doDisplayInfo", error);
    }
  }

  const isFilteredSorted = () => {
    let dateFrom = localStorage.getItem(TUID.current + '_date_from');
    let dateTo = localStorage.getItem(TUID.current + '_date_to');
    let sortBy = localStorage.getItem(TUID.current + '_sorting');
    return Boolean(search || dateFrom || dateTo || sortBy);
  }

  const clearFilteredSorted = () => {
    localStorage.removeItem(TUID.current + '_date_from');
    localStorage.removeItem(TUID.current + '_date_to');
    localStorage.removeItem(TUID.current + '_sorting');
    clearSearch();
  }

  const getTotal = () => {
    try {
      let dateFrom = localStorage.getItem(TUID.current + '_date_from');
      let dateTo = localStorage.getItem(TUID.current + '_date_to');
      let sortBy = localStorage.getItem(TUID.current + '_sorting') || "dtCrea";
      let group = '';
      if (rest.group) {
        group = rest.group;
      }
      // record
      let record = {};
      record['searchText'] = rf_search.current ? rf_search.current.getVal() || '' : '';
      record['tooltip'] = tooltip;
      record['pageNo'] = '0';
      record['pageSize'] = '1000000';
      record['dateFrom'] = dateFrom;
      record['dateTo'] = dateTo;
      record['sortBy'] = sortBy;
      record['filter'] = filter;
      record['filterHaving'] = filterHaving;
      record['group'] = group;
      if (addParams) {
        let params = addParams.split("&");
        params.forEach(function (item, index) {
          record[item.split("=")[0]] = item.split("=")[1];
        });
      }
      r_dlg_alert.current.setOpen(true);
      return Promise.all([FxFetch.doJsonX(txUrl.current, record)]).then((result) => {
        r_dlg_alert.current.setOpen(false);
        if (result[0]) {
          if (result[0].length > 0) {
            return result[0].length;
          }
        }
      });

    } catch (error) {
      FxLog.errorx("CxTable.getTotal", error);
    }
  }

  const openOptions = (e) => {
    if (e && e.ctrlKey) {
      if (onSpecialOptions) {
        onSpecialOptions();
      }
    } else {
      setDlgOptions(true);
    }
  }

  return (
    <div id='CxTable' style={{ display: 'block', margin: rest.margin }}>
      {rest.title && <CxHr title={rest.title} />}
      <div id='CxTable_header' style={{ display: rest.hasSearchBox ? 'flex' : 'none', flexWrap: 'wrap', margin: '0px' }}>
        <div id='CxTable_CxInput' className={'table_search_container'}>
          {rest.hasSearchBox &&
            <>
              <CxInput
                xref={rf_search}
                label={trans('field.search')}
                tooltip={tooltip}
                onKeyDown={(e) => { 
                  FxLog.infox('CxTable.return.onKeyDown', '...e.keyCode:', e.keyCode);
                  if (e.keyCode === 13) doSearch();
                  if (e.keyCode === 27) clearSearch();
                }}
                onClear={clearSearch}
                onSearch={doSearch}
                width={size.isLarge ? 'var(--ibs_search_width_lg)' : 'var(--ibs_search_width_sm)'}
                speechExternal={rest.speechExternal}
                onSpeechFinish={doSearch}
                autoselect="true"
              />
              <div style={{ height: '30px', /* width: '30px', */ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {rest.showtip && size.isLarge && <a tabIndex='-1' href={`https://iberical.com/ibericalhelp/${getStoreValue('StoreSession', 'txLocale').substring(0,2)}_${getStoreValue('StoreSession', 'txApp')}.php#section_mods_${'fsteps_search'}`} target="_blank" rel="noreferrer" >
                  {/* // 2024-05-07 - daq: sólo lo muestro si la parte servidor está preparada (usa XUtils.getQyCondition()), y en pantalla grande xq en el móvil se puede pulsar por error con el dedo */}
                  <CxIconButtonNew icon={<BiInfoCircle fontSize={19} style={{ margin: '0px 0 0 0px' }} />} />
                </a>}
                {rest.speechExternal && 
                  <CxIconButtonNew icon={<BiMicrophone fontSize={20} />} style={{ margin: '0px 0 0 2px' }}
                    onMouseDown={() => rf_search.current.doSpeech(1)} 
                    onMouseUp={() => rf_search.current.doSpeech(0)} 
                  />
                } {/* OJO ESTE BOTÓN NO ES EL MISMO QUE HAY EN CXTABLE */}
                
              </div>
              {rest.action1 && 
                <CxIconButtonNew xref={rf_button_action1} 
                  icon={rest.action1.iconOff} 
                  classType={'table_button'} 
                  onClick={() => {
                    rf_button_action1.current.setIcon(rf_button_action1.current.getState()==='OFF' ? rest.action1.iconOn : rest.action1.iconOff)
                    rest.action1.onClick();
                  }
                  } 
                  tooltip={rest.action1.tooltip} 
                />
              }
            </>
          }
        </div>
        <div style={{ flexGrow: 1 }}>
          {rest.children}
        </div>
      </div>
      <div id='CxTable_MuiTable'>
        <MuiTable className={getStyle()} {...getTableProps()}>
          <TableHead>
            {headerGroups.map(headerGroup => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <TableCell align={column.align} width={column.width} {...column.getHeaderProps()}>
                    {/* 2023-04-10 - daq: si se definió un ícono, se usa ése. */}
                    {column.icon ?
                      <CxIconButtonNew icon={column.icon} icon_alt={column.icon_alt} classType={'ibs_iconbutton_table_header'} onClick={column.onIconClick} tooltip={column.iconTooltip} />
                      :
                      column.render("Header")
                    }
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>

          <TableBody>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
              <TableRow 
                {...row.getRowProps()} 
                className="table_row_hover"
                onMouseEnter={fxTooltipText ? (e) => {
                  setObTooltip({
                    boShow: true,
                    nuX: e.clientX,
                    nuY: e.clientY,
                    txText: fxTooltipText(row.original)
                  });
                } : null}
                onMouseLeave={fxTooltipText ? () => {
                  setObTooltip((obPrev) => ({ ...obPrev, boShow: false }));
                } : null}
              >
                  {row.cells.map((cell, iCell) => {
                    return (
                      <TableCell onClick={(e) => formUpdate(cell, e.ctrlKey)}
                        className={getCellClassName(cell, iCell)}
                        align={getHeaderSetting(iCell, 'align')}
                        {...cell.getCellProps()}
                      >
                        {cell.column.highlight
                          ? highlightText(cell.value, cell.column.id)
                          : cell.column.highlightDate
                            ? highlightDate(cell.value, cell.column.id)
                            : cell.render("Cell")
                        }
                      </TableCell>
                    );
                  })}                  
                </TableRow>
              );
            })}
          </TableBody>

        </MuiTable>

        <CxProgress wait={progress} />

        {!rest.origin && isFilteredSorted() && 
          <div style={{ fontSize: '10px', color: 'red', fontWeight: 'bold', fontStyle: 'italic', marginTop: '5px' }}>
            {trans('msg.list_filtered_sorted').toUpperCase()}
            <CxLink label={`[${trans('field.restore').toUpperCase()}]`} width='120px' style={{ margin: '0 0 0 5px', fontSize: '9px' }}  onClick={() => clearFilteredSorted()} />
          </div>
        }
        {!rest.origin && timeElapsed>3 && rest.optionalFromTo && !search &&
          <div style={{ fontSize: '10px', color: 'red', fontWeight: 'bold', fontStyle: 'italic', marginTop: '5px' }}>
            <CxLink label={`[${trans('msg.reduce_waiting_time').toUpperCase()}]`} width='120px' style={{ fontSize: '9px' }}  onClick={openOptions} />
          </div>
        }

        <div id='CxTable_buttons' className={'table_button_container'}>
          <div className={'table_button_container_side'}>
            {rest.addTableButtonsLeft}
          </div>
          <div className={'table_button_container_center'}>
            {onOptions && (size.isLarge || rest.forceOptions) && <CxIconButtonNew icon={<IoSettingsOutline fontSize={BUTTON_FONTSIZE - 1} />} classType={'table_button'} onClick={openOptions} tooltip={trans('field.options')} />}
            {(refColors||refSuffixes) && <CxIconButtonNew icon={<IoInformationCircleOutline fontSize={BUTTON_FONTSIZE} />} classType={'table_button'} onClick={() => doDisplayInfo()} tooltip={trans('field.information')} />}
            <CxIconButtonNew icon={<IoPlaySkipBackCircleOutline fontSize={BUTTON_FONTSIZE} />} classType={'table_button'} onClick={goPageFirst} tooltip={trans('field.page_first')} />
            <CxIconButtonNew icon={<IoCaretBackCircleOutline fontSize={BUTTON_FONTSIZE} />} classType={'table_button'} onClick={goPagePrev} tooltip={trans('field.page_prev')} />

            <span className={'table_label_page'} onClick={() => setDlgGotoPage(true)} >
              {pageNo + 1}
            </span>

            <CxIconButtonNew icon={<IoCaretForwardCircleOutline fontSize={BUTTON_FONTSIZE} />} classType={'table_button'} onClick={goPageNext} tooltip={trans('field.page_next')} />
            {rest.hasButtonAdd && !disabled && 
              <CxIconButtonMenu xref={rf_button_add} 
                icon={<IoAddCircleOutline fontSize={BUTTON_FONTSIZE} />} 
                onSelection={(option) => formAdd(option)} 
                className="table_button"
                tooltip={trans('field.add')}
              />
            }
          </div>
          <div className={'table_button_container_side'} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
            {rest.addTableButtonsRight}
          </div>
        </div>

      </div>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxDialog 
        title={trans('msg.go_to_x','field.page')} 
        open={dlgGotoPage} 
        onOk={() => goToPage(rf_goto_page.current.getVal())} 
        onCancel={() => setDlgGotoPage(false)} 
        height='180px'
        >
        <CxNumber xref={rf_goto_page}
          decimals={0}
          allowpositive="true"
          required
          width='var(--ibs_control_width_sm)'
          autoFocus={size.isLarge}
        />
      </CxDialog>

      <CxDialog /* isLargeWindow={size.isLarge} */
        title={trans('field.options')}
        open={dlgOptions}
        onOk={() => optionsSelected()}
        onClose={() => setDlgOptions(false)}
      >
        {rest.optionalColumns &&
          <CxMultiCheck mode='checkbox' xref={rf_optional_columns}
            label={trans('field.additional_columns')}
            minRows={4}
            itemWidth="200px"
            list={rest.optionalColumns}
            width='var(--ibs_control_width_lg)'
          />
        }
        {rest.optionalSorting &&
          <CxCombo xref={rf_optional_sorting}
            label={`${trans('field.order_by')}`}
            list={rest.optionalSorting}
            width='var(--ibs_control_width_lg)'
            defaultValue={localStorage.getItem(TUID.current + '_sorting')}
          />
        }
        {rest.optionalFromTo &&
          <>
            <CxDate xref={rf_optional_from} label={trans('field.from')} defaultValue={localStorage.getItem(TUID.current + '_date_from')} autoselect="true" />
            <CxDate xref={rf_optional_to} label={trans('field.to')} defaultValue={localStorage.getItem(TUID.current + '_date_to')} autoselect="true" minDateRef={rf_optional_from} />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '0px' }}>
              {rest.optionalFromToButtonToday && <CxLink label={`[${trans('field.today').toUpperCase()}]`} width='50px'
                style={{ margin: '0 0 0 0px', fontSize: '11px' }} 
                onClick={() => {
                  rf_optional_from.current.setValToday();
                  rf_optional_to.current.setValToday();
                }} 
              />}
              {rest.optionalFromToButtonLast7Days && <CxLink label={`[${trans('field.last_x_days', '7').toUpperCase()}]`} width='120px'
                style={{ margin: '0 0 0 0px', fontSize: '11px' }} 
                onClick={() => {
                  rf_optional_from.current.setValTodayAdd(-7);
                  rf_optional_to.current.setValToday();
                }} 
              />}
              {rest.optionalFromToButtonNext7Days && <CxLink label={`[${trans('field.next_x_days', '7').toUpperCase()}]`}  width='120px'
                style={{ margin: '0 0 0 0px', fontSize: '11px' }} 
                onClick={() => {
                  rf_optional_from.current.setValToday();
                  rf_optional_to.current.setValTodayAdd(7);
                }} 
              />}
              {rest.optionalFromToButtonLast30Days && <CxLink label={`[${trans('field.last_x_days', '30').toUpperCase()}]`} width='120px'
                style={{ margin: '0 0 0 0px', fontSize: '11px' }} 
                onClick={() => {
                  rf_optional_from.current.setValTodayAdd(-30);
                  rf_optional_to.current.setValToday();
                }} 
              />}
            </div>
          </>
        }
      </CxDialog >

      <CxDialog /* isLargeWindow={size.isLarge} */
        title={trans('field.information')}
        open={dlgInfo}
        onClose={() => setDlgInfo(false)}
        height='250px'>
        <div style={{ height: '250px', width: '250px', }}>
          {infoTotal && <div>{trans('field.records') + ': '}{infoTotal}</div>} {/* // 2024-04-16 - daq: si hay demasiados registros, sucede un timeout entonces nosotros no mostramos esta línea. */}
          <hr className="table_cell_color_ref_hr" />
          {refColors && <div style={{ marginTop: '5px', }}>
            <ul className='table_cell_color_ref_ul'>
              {refColors.map(function (name, index) {
                return name === '' ? '' : <li className={name.split('|')[0]} key={index}>{name.split('|')[1]}</li>;
              })}
            </ul>
          </div>}
          {refSuffixes && <div style={{ marginTop: '5px', }}>
            <table>
              <tbody>
                {refSuffixes.map(function (name, index) {
                  return <tr key={index}>
                    <td style={{ paddingLeft: '15px', fontWeight: 'bold', }}>{name.split('|')[0]}</td>
                    <td style={{ paddingLeft: '7px', }}>{name.split('|')[1]}</td>
                  </tr>;
                })}
              </tbody>
            </table>
          </div>}
        </div>
      </CxDialog>

      <CxDlgUpgrade xref={r_dlg_upgrade} />

      {obTooltip.boShow && (
        <div style={{
          position: 'fixed',
          top: obTooltip.nuY + 15,
          left: obTooltip.nuX + 15,
          backgroundColor: 'rgba(33, 33, 33, 0.95)',
          color: '#ffffff',
          padding: '6px 12px',
          borderRadius: '4px',
          zIndex: 9999,
          pointerEvents: 'none',
          fontSize: '12px',
          boxShadow: '0px 4px 6px rgba(0,0,0,0.3)',
          border: '1px solid #555',
          textAlign: 'left',
          
          // 2024-04-16 - Asistente: Control de Wrap para textos largos
          maxWidth: '300px',          // Ancho máximo antes de romper la línea
          whiteSpace: 'pre-wrap',     // Hace wrap automático y respeta los saltos de línea (\n) si los envías
          overflowWrap: 'break-word'  // Evita que palabras súper largas (ej. un ID continuo) rompan la caja
        }}>
          {obTooltip.txText}
        </div>
      )}

    </div >
  );

};

export default CxTable;
